import { useTranslation } from 'react-i18next';

import { useUserProfile } from '@/states/user-profile';
import { EMPTY_VALUE } from '@/utils/strings';

import { SidebarTrigger } from './ui/sidebar';
import { LanguageSwitcher } from './language-switcher';

export const GlobalHeader = () => {
  const { profile } = useUserProfile();
  const { t } = useTranslation();

  return (
    <header className="py-4 border-border border-b">
      <div className="relative w-full max-w-7xl mx-auto flex justify-between items-center">
        <div className="inline-flex items-center gap-2">
          <SidebarTrigger className="inline-block lg:hidden" />
          <div className="clinic-name-wrapper">
            <div className="hidden lg:block text-xs text-primary font-bold">
              {t('header-your-clinic')}
            </div>
            <p className="lg:text-2xl font-bold">{profile.clinic_name ?? EMPTY_VALUE}</p>
          </div>
        </div>
        <div className="hidden lg:block">
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
};
